import { writable } from 'svelte/store';

export const loadingPopupFlag = writable(false);
export const loadingMessage = writable('');

const loadingMessages = {
	imageUpload: '이미지를 업로드 중입니다.',
	imageCreate: '이미지를 생성하는 중입니다.',
	promptCreate: '프롬프트를 생성하는 중입니다.',
	loading: '로딩 중입니다.'
};

export const showLoadingPopup = (type = 'loading') => {
	loadingMessage.set(loadingMessages[type] || '로딩 중입니다...');
	loadingPopupFlag.set(true);
}

export const hideLoadingPopup = () => {
	loadingPopupFlag.set(false);
}
